<div id="home-warnings-and-alerts">
  <div class="header">
    <span>{{ 'doktar_app.home.alerts_title' | translate }}</span>
  </div>
  <div class="tabs">
    <dk-tabs
      [selectableTabs]="alertTabs"
      [currentTab]="selectedAlertTab"
      (tabChange)="changeAlertTab($event)"
      [defaultlyGrey]="true"></dk-tabs>
  </div>
  @if (!alertFeedsLoading) {
    @if (dataSourceKey) {
      <div class="data-source">
        <span>{{ dataSourceKey | translate }}</span>
        @if (hasWeatherHorizon) {
          <span class="data-source-window">{{
            'doktar_app.home.warnings.for_next_n_hours' | translate: { arg1: weatherHorizonHours }
          }}</span>
        }
      </div>
    }
    <div class="feed">
      <!-- ALL Tab - Single scrollable container for all alerts -->
      @if (selectedAlertTab == alertTabs[0]) {
        <div class="tab-content">
          @if (!hasAnyAlertFeeds) {
            @if (fetchingError) {
              <widget-info-box
                [isErrorState]="true"
                [title]="'doktar_app.home.warnings.not_load_all' | translate"
                [description]="'doktar_app.home.warnings.not_load_all_description' | translate"
                (primaryButtonClick)="getAlertFeeds()"></widget-info-box>
            } @else {
              <widget-info-box
                [isErrorState]="false"
                [icon]="'ph ph-thumbs-up'"
                iconColor="#000"
                [title]="'doktar_app.home.warnings.all_empty_title' | translate"
                [description]="'doktar_app.home.warnings.all_empty_description' | translate"></widget-info-box>
            }
          } @else {
            @if (weatherCards.length > 0) {
              <ng-container [ngTemplateOutlet]="weatherCardsTpl" />
            }
            @if (pestsFeeds.length > 0) {
              <ng-container [ngTemplateOutlet]="pestCardsTpl" />
            }
            @if (diseaseRiskFeeds.length > 0) {
              <ng-container [ngTemplateOutlet]="diseaseCardsTpl" />
            }
          }
        </div>
      }
      <!-- Weather Tab -->
      @if (selectedAlertTab == alertTabs[1]) {
        <div class="tab-content">
          @if (weatherCards.length === 0) {
            @if (fetchingError) {
              <widget-info-box
                [isErrorState]="true"
                [title]="'doktar_app.home.warnings.not_load_weather' | translate"
                [description]="'doktar_app.home.warnings.not_load_weather_description' | translate"
                (primaryButtonClick)="getAlertFeeds()"></widget-info-box>
            } @else {
              <widget-info-box
                [isErrorState]="false"
                [icon]="'ph ph-cloud-sun'"
                iconColor="#000"
                [title]="'doktar_app.home.warnings.weather_empty_title' | translate"
                [description]="'doktar_app.home.warnings.weather_empty_description' | translate"></widget-info-box>
            }
          } @else {
            <ng-container [ngTemplateOutlet]="weatherCardsTpl" />
          }
        </div>
      }
      <!-- Pests Tab -->
      @if (selectedAlertTab == alertTabs[2]) {
        <div class="tab-content">
          @if (hasPestDevice) {
            @if (pestsFeeds?.length === 0) {
              @if (fetchingError) {
                <widget-info-box
                  [isErrorState]="true"
                  [title]="'doktar_app.home.warnings.not_load_pest' | translate"
                  [description]="'doktar_app.home.warnings.not_load_pest_description' | translate"
                  (primaryButtonClick)="getAlertFeeds()"></widget-info-box>
              } @else {
                <widget-info-box
                  [isErrorState]="false"
                  [icon]="'ph ph-bug-beetle'"
                  iconColor="#000"
                  [title]="'doktar_app.home.warnings.pest_no_risk_title' | translate"
                  [description]="'doktar_app.home.warnings.pest_no_risk_description' | translate"></widget-info-box>
              }
            } @else {
              <ng-container [ngTemplateOutlet]="pestCardsTpl" />
            }
          } @else {
            <widget-no-device (triggerRetry)="getAlertFeeds()" (requestCallbackEvent)="requestCallbackEvent.emit()" />
          }
        </div>
      }
      <!-- Disease Risk Tab -->
      @if (selectedAlertTab == alertTabs[3]) {
        <div class="tab-content">
          @if (diseaseRiskFeeds?.length == 0) {
            @if (fetchingError) {
              <widget-info-box
                [isErrorState]="true"
                [title]="'doktar_app.home.warnings.not_load_disease_risk' | translate"
                [description]="'doktar_app.home.warnings.not_load_disease_risk_description' | translate"
                (primaryButtonClick)="getAlertFeeds()"></widget-info-box>
            } @else {
              <widget-info-box
                [isErrorState]="false"
                [icon]="'ph ph-grains'"
                iconColor="#000"
                [title]="'doktar_app.home.warnings.disease_risk_empty_title' | translate"
                [description]="'doktar_app.home.warnings.disease_risk_empty_description' | translate"></widget-info-box>
            }
          } @else {
            <ng-container [ngTemplateOutlet]="diseaseCardsTpl" />
          }
        </div>
      }
    </div>
  } @else {
    <div class="mt-3">
      <p-skeleton width="100%" height="4rem" styleClass="mb-3" />
      <p-skeleton width="100%" height="4rem" styleClass="mb-3" />
      <p-skeleton width="100%" height="4rem" styleClass="mb-2" />
    </div>
  }

  <ng-template #weatherCardsTpl>
    <div class="weather-feed-container">
      @for (card of weatherCards; track card.plantationId + card.landId + card.alertName) {
        <div class="disease-feed-item weather-feed-item">
          <div class="weather-card-header">
            <div class="disease-header">
              <div class="card-content">
                <div class="plantation-placeholder">
                  <div
                    class="card-image"
                    [dkSafeImage]="card.plantationImage"
                    fallbackImage="/assets/images/lp/land-plantation-thumbnail-base.png"
                    backgroundStyle="lightgray 50% / cover no-repeat"
                    [showSpinner]="true"></div>
                </div>
                <div class="plantation-info">
                  <div class="content">
                    <span class="dot" [style.color]="card.cropColor">{{ '•' }}</span>
                    <span class="title">{{ card.plantationName }}</span>
                  </div>
                  <div class="details">
                    <span class="description">
                      {{ card.landName }}
                    </span>
                  </div>
                </div>
              </div>
              @if (card.alertLevel) {
                <div class="risk-level">
                  <span
                    class="risk-level-label"
                    [style.background-color]="getWeatherRiskLevel(card.alertLevel) == 3 ? '#F8F0EC' : '#FFF1D6'"
                    [style.color]="getWeatherRiskLevel(card.alertLevel) == 3 ? '#E11900' : '#EE9F00'">
                    @if (getWeatherRiskLevel(card.alertLevel) == 3) {
                      {{ 'doktar_app.home.disease_risk_level_high' | translate }}
                    } @else {
                      {{ 'doktar_app.home.disease_risk_level_low' | translate }}
                    }
                  </span>
                </div>
              }
            </div>
          </div>
          <div class="accordion-footer weather-footer">
            <div class="subject">
              @if (card.icon) {
                <img class="alert-icon" [src]="card.icon" alt="" />
              } @else {
                <i class="ph-fill ph-cloud-sun"></i>
              }
              <span class="title">
                {{ card.alertName }}
              </span>
            </div>
            @if (card.alertDescription) {
              <span class="time-content-description">
                {{ card.alertDescription }}
              </span>
            }
          </div>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #pestCardsTpl>
    <div class="pest-feed-container">
      <p-accordion
        value="0"
        (onOpen)="onPestAccordionOpen($event)"
        [ngStyle]="{ width: '100%', gap: '16px', display: 'flex', 'flex-direction': 'column' }"
        [expandIcon]="'ph ph-caret-down'"
        [collapseIcon]="'ph ph-caret-up'">
        @for (pestRisk of pestsFeeds; track $index) {
          <p-accordion-panel [value]="$index" class="disease-feed-item">
            <p-accordion-header [style.border-radius]="'12px 12px 12px 12px'" [style.align-items]="'flex-start'">
              <div class="disease-header">
                <div class="card-content">
                  <div class="plantation-placeholder">
                    <div
                      class="card-image"
                      [dkSafeImage]="pestRisk?.plantationImage"
                      fallbackImage="/assets/images/lp/land-plantation-thumbnail-base.png"
                      backgroundStyle="lightgray 50% / cover no-repeat"
                      [showSpinner]="true"></div>
                  </div>
                  <div class="plantation-info">
                    <div class="content">
                      <span class="dot" [style.color]="pestRisk.cropColor">{{ '•' }}</span>
                      <span class="title">{{ pestRisk.plantationName }}</span>
                    </div>
                    <div class="details">
                      <span class="description">
                        {{ pestRisk?.landName }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="risk-level">
                  <span class="risk-level-label" [style.background-color]="'#FCEBFF'" [style.gap]="'4px'">
                    <i class="ph-fill ph-trend-up"></i>
                    <span
                      safeTranslate="doktar_app.common.pests_count"
                      [translateParams]="{ arg1: pestRisk.increase }"></span>
                  </span>
                </div>
              </div>
            </p-accordion-header>
            <p-accordion-content>
              <widget-pest-details [pestRisk]="pestRisk"></widget-pest-details>
            </p-accordion-content>
            <div class="accordion-footer" [style.background-color]="'#FCEBFF'">
              <div class="subject">
                <i class="ph-fill ph-bug-beetle"></i>
                <span class="title">
                  {{ pestRisk.pestName }}
                </span>
              </div>
              <span class="time-content-description">
                {{ 'doktar_app.home.pest_risk.increase_alert_details' | translate }}
              </span>
            </div>
          </p-accordion-panel>
        }
      </p-accordion>
    </div>
  </ng-template>

  <ng-template #diseaseCardsTpl>
    <div class="disease-feed-container">
      <p-accordion
        [(value)]="openDiseasePanel"
        (onOpen)="onDiseaseAccordionOpen($event)"
        [ngStyle]="{ width: '100%', gap: '16px', display: 'flex', 'flex-direction': 'column' }"
        [expandIcon]="'ph ph-caret-down'"
        [collapseIcon]="'ph ph-caret-up'">
        @for (diseaseRisk of diseaseRiskFeeds; track $index) {
          <p-accordion-panel [value]="$index" class="disease-feed-item">
            <p-accordion-header [style.border-radius]="'12px 12px 12px 12px'" [style.align-items]="'flex-start'">
              <div class="disease-header">
                <div class="card-content">
                  <div class="plantation-placeholder">
                    <div
                      class="card-image"
                      [dkSafeImage]="diseaseRisk?.plantationImage"
                      fallbackImage="/assets/images/lp/land-plantation-thumbnail-base.png"
                      backgroundStyle="lightgray 50% / cover no-repeat"
                      [showSpinner]="true"></div>
                  </div>
                  <div class="plantation-info">
                    <div class="content">
                      <span class="dot" [style.color]="diseaseRisk.cropColor">{{ '•' }}</span>
                      <span class="title">{{ diseaseRisk.plantationName }}</span>
                    </div>
                    <div class="details">
                      <span class="description">
                        {{ diseaseRisk?.landName }}
                      </span>
                    </div>
                  </div>
                </div>
                @if (showDiseaseHeaderBadge($index, diseaseRisk.diseaseRiskDates)) {
                  <div class="risk-level">
                    <span
                      class="risk-level-label"
                      [style.background-color]="
                        getDiseaseRiskLevel(diseaseRisk.diseaseRiskDates) == 3
                          ? '#F8F0EC'
                          : getDiseaseRiskLevel(diseaseRisk.diseaseRiskDates) == 1
                            ? '#FFF1D6'
                            : '#000'
                      "
                      [style.color]="
                        getDiseaseRiskLevel(diseaseRisk.diseaseRiskDates) == 3
                          ? '#E11900'
                          : getDiseaseRiskLevel(diseaseRisk.diseaseRiskDates) == 1
                            ? '#EE9F00'
                            : '#000'
                      ">
                      @if (getDiseaseRiskLevel(diseaseRisk.diseaseRiskDates) == 1) {
                        {{ 'doktar_app.home.disease_risk_level_low' | translate }}
                      } @else if (getDiseaseRiskLevel(diseaseRisk.diseaseRiskDates) == 3) {
                        {{ 'doktar_app.home.disease_risk_level_high' | translate }}
                      }
                    </span>
                  </div>
                }
              </div>
            </p-accordion-header>
            <p-accordion-content>
              <widget-week-days
                [diseaseDays]="diseaseRisk?.diseaseRiskDates"
                [showRiskBadges]="hasMultipleRiskLevels(diseaseRisk?.diseaseRiskDates)"></widget-week-days>
            </p-accordion-content>
            <div
              class="accordion-footer"
              [style.background-color]="
                getDiseaseRiskLevel(diseaseRisk?.diseaseRiskDates) == 3
                  ? '#F8F0EC'
                  : getDiseaseRiskLevel(diseaseRisk?.diseaseRiskDates) == 1
                    ? '#FEC'
                    : '#000'
              ">
              <div class="subject">
                <i class="ph-fill ph-virus"></i>
                <span class="title">
                  {{ diseaseRisk.diseaseName }}
                </span>
              </div>
              <span class="time-content-description">
                {{
                  expectedLastDayText(diseaseRisk.diseaseRiskDates) > 1
                    ? ('doktar_app.home.expected_risk_day_plural'
                      | translate
                        : {
                            arg1: expectedLastDayText(diseaseRisk.diseaseRiskDates),
                          })
                    : ('doktar_app.home.expected_risk_day' | translate)
                }}
              </span>
            </div>
          </p-accordion-panel>
        }
      </p-accordion>
    </div>
  </ng-template>
</div>
